// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Benutzer, BenutzerDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useCreateBenutzer(): (
  requestBody: BenutzerDaten
) => Promise<Benutzer> {
  const getAPI = useGetApi();
  return useCallback(
    async (requestBody) =>
      (await getAPI()).benutzer.createBenutzer({ requestBody }),
    [getAPI]
  );
}
